module.exports = __webpack_public_path__ + "img/course-slider-3.6f95ae9c.png";